(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    root.querySelectorAll('a[href^="#"]').forEach((link) => link.addEventListener('click', (event) => {
      const target = root.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault(); event.stopPropagation();
      target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }));
    const selector = root.querySelector('[data-model-select]');
    const products = [...root.querySelectorAll('[data-model]')];
    const unique = new Map();
    products.forEach((item) => unique.set(item.dataset.model, item.dataset.modelLabel));
    const score = (value) => Number(value) || ({ XR: 10.2, X: 10.1, SE: 7 }[value] || 0);
    [...unique].sort((a, b) => score(b[0]) - score(a[0])).forEach(([value, label]) => {
      const option = document.createElement('option');
      option.value = value; option.textContent = label; selector.append(option);
    });
    const filter = () => {
      root.dataset.filtered = String(selector.value !== 'all');
      products.forEach((product) => { product.hidden = selector.value !== 'all' && product.dataset.model !== selector.value; });
      root.querySelectorAll('[data-family]').forEach((family) => {
        const available = [...family.querySelectorAll('[data-model]')].some((product) => !product.hidden);
        family.querySelector('[data-no-model]').hidden = available;
      });
      const count = products.filter((product) => !product.hidden).length;
      root.querySelector('[data-filter-status]').textContent = `${count} sélection${count > 1 ? 's' : ''} disponible${count > 1 ? 's' : ''} · choisissez ensuite votre modèle exact et votre finition.`;
    };
    selector.addEventListener('change', filter);
    root.querySelectorAll('[data-show-all]').forEach((button) => button.addEventListener('click', () => { selector.value = 'all'; filter(); root.querySelector('[data-model-control]').scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); selector.focus({ preventScroll: true }); }));
    root.querySelector('[data-model-control]').hidden = false;
    filter();
    root.querySelector('[data-copy-code]').addEventListener('click', async () => {
      const status = root.querySelector('[data-copy-status]');
      try { await navigator.clipboard.writeText('PRIVE40'); status.textContent = 'Code copié !'; }
      catch { status.textContent = 'À saisir au paiement : PRIVE40'; }
    });
  };
  document.querySelectorAll('[data-private-sale]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-private-sale]').forEach(initialize));
})();
